// extracted by mini-css-extract-plugin
module.exports = {"viatorProductCardImage":"providers-viator-components-ViatorProductCard-ViatorProductCardImage-ViatorProductCardImage__viatorProductCardImage--3YuTy"};